import LoginHeader from "../layouts/LoginHeader.component";
import Sidebar_Progress from "../layouts/Sidebar_Progress.component";
import ReactDOM from 'react-dom';
import payment from '../../img/payment-method.svg'
import EmployeeModal from './EmployeeModal'
import { useState } from 'react';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { API_URL } from "../../constant/API_Settings";
import swal from "sweetalert";
import { Link } from "react-router-dom";
import Modal from "react-modal";
var SaveModal = (props) => ReactDOM.createPortal(
  <EmployeeModal  {...props} />, document.body
);
const EmployeeOpeningBalance = () => {
  const UseModal = () => {

    const [isShowing, setIsShowing] = useState(false);

    function toggle() {
      if (isShowing) {
        setInputValues([])
        setErrors({})
        setSuccess({})

      }
      setIsShowing(!isShowing);
    }

    return {
      isShowing,
      toggle,
    }
  };
  const [isOpen, setIsOpen] = useState(false);
  function toggleModal() {
    setIsOpen(!isOpen);
  }
  const [delete_id, deleteId] = useState([])
  const [search, setSearch] = useState('')
  const handleSearch = (event) => {
    setSearch(event.target.value)
  }


  useEffect(() => {
    check_url()
    ListEmployee(pages.current_page);
  }, [search]);


  
	 //------------------------url
function check_url() {
	const requestOptions = {      
		method: 'post',
		headers: {
			"Access-Control-Allow-Origin": "*",
			"Content-Type": "application/json",
			"Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN") + "",
			"Accept": "application/json"
		},
		body: JSON.stringify({
			pathurl: window.location.pathname,
		}),
	};
	fetch(`${API_URL}/check_url`, requestOptions)
		.then(response => { return response.json(); })

		.then(responseData => {
			console.log(responseData)
			if(responseData.allowurl == 1)
			{
				history.push(responseData.url);
				check_meta_date();
			}
			else{
				
				history.goBack();
			}

			return responseData;
		})
		.catch(e => {
		});

}
function check_meta_date() {

	const requestOptions = {      
		method: 'post',
		headers: {
			"Access-Control-Allow-Origin": "*",
			"Content-Type": "application/json",
			"Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN") + "",
			"Accept": "application/json"

		}
	};
	fetch(`${API_URL}/check_meta_date`, requestOptions)
		.then(response => { return response.json(); })
		.then(responseData => {
		//	console.log(responseData.op_date)
		

			return responseData;
		})
		.catch(e => {
		});

}




  const handleSubmit = (event) => {
    event.preventDefault();

    if (validateForm())
      sendEmployeeDetails()

  }
  const handleInputs = (e) => {
    setInputValues({
      ...inputValues,
      [e.target.name]: e.target.value
    });
  };

  const [pages, setpages] = useState(
    {
      current_page: 1,
      last_page: 0,
      total_pages: 0,
      pagination_item: [],
      total_pages: 0,
    })

  const handlePagination = (number) => {
    setpages({
      ...pages,
      current_page: number
    }
    )

    ListEmployee(number)

  }
  function ListEmployee(page) {
    const requestOptions = {
      method: 'get',
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN") + "",
        "Accept": "application/json"

      },
    };

    fetch(`${API_URL}/employee?search_keyword=${search}&page=${page}`, requestOptions)
      .then(response => { return response.json(); })
      .then(responseData => {
        console.log(responseData)
        setList(responseData.data)
        var total_pages = responseData.last_page

        var items = []
        for (let number = 1; number <= total_pages; number++) {
          number === page ? items.push(
            <li key={number} className="page-item active"><a className="page-link" onClick={() => handlePagination(number)}>{number}</a></li>
          ,) : items.push(
              <li key={number} className="page-item"><a className="page-link" onClick={() => handlePagination(number)}>{number}</a></li>
          ,)
        }

        setpages({
          ...pages,
          current_page: responseData.current_page,
          last_page: responseData.last_page,
          total_pages: responseData.last_page,
          pagination_items: items
        })


        // console.log(list) 
        return responseData;
      })
      .catch(e => {
        console.log(e);

      });
  }

  function delete_employee(id) {
    console.log(id)
    deleteId(id)

    toggleModal()
  }

  function deleteEmployee() {

    // console.log(...delete_id)
    const requestOptions = {
      method: 'DELETE',

      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN") + "",
        "Accept": "application/json"

      },
      body: JSON.stringify(delete_id)
    };
    fetch(API_URL + "/employee/" + delete_id, requestOptions)
      .then(response => { return response.json(); })
      .then(responseData => {
        swal("", responseData.message, responseData.status ? "success" : "warning")
        ListEmployee(pages.current_page);
        toggleModal()

        return responseData;


      })

      .catch(err => {

      })
  }

  function edit_Employee(id, ac_name, ac_name1) {
    console.log(id)
    const requestOptions = {
      method: 'get',
      data: {
        id: id,
        ac_name: ac_name,
        ac_name1: ac_name1

      },
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN") + "",
        "Accept": "application/json"

      },
    };
    fetch(API_URL + "/employee/" + id + "/edit", requestOptions)
      .then(response => { return response.json(); })
      .then(responseData => {
        console.log(responseData)
        setInputValues(
          {
            id: responseData.id ? responseData.id : '',
            ac_name: responseData.ac_name ? responseData.ac_name : '',
            ac_name1: responseData.ac_name1 ? responseData.ac_name1 : '',
            name: responseData.name,
            address: responseData.address,
            phone: responseData.phone,
            email: responseData.email,
            designation: responseData.designation,
            user_name: responseData.user_name,
            password: responseData.password,
            debit_credit: responseData.debit_credit,
            opening_balance: responseData.opening_balance
          }
        );
        // }) 
        toggle();
        // setInputValues("")
        return responseData;
      })
      .catch(e => {
        console.log(e);

      });
  }

  function validateForm() {
    let errors = []
    let formIsValid = true
    if (!inputValues.name) {
      formIsValid = false;
      errors["name"] = "Enter  Employee Name"
    }
    else {
      errors["name"] = ""
    }


    if (inputValues.opening_balance != undefined) {
      if ((inputValues.opening_balance != "") && (inputValues.debit_credit == undefined || inputValues.debit_credit === "")) {
        formIsValid = false;
        errors["debit_credit"] = " Select Debit/Credit"
      }

    }
    setErrors(errors)

    return formIsValid;


  }
  function sendEmployeeDetails() {
    setErrors({})
    const requestOptions = {
      method: 'POST',
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN") + "",
        "Accept": "application/json"
      },
      body: JSON.stringify(inputValues)
    };
    fetch(API_URL + "/employee", requestOptions)
      .then(response => {
        return response.json();
      })
      .then(responseData => {
        console.log(responseData.status)
        setSuccess({
          ...success,
          disabled: responseData.status === true ? true : false,
        })
        let errors = []
        if (responseData.status == false) {
          if (responseData.message != undefined) {
            swal("", responseData.message)
          }
          else {
            // errors["name"] = responseData.message
            errors["phone"] = responseData.response.phone
            errors["email"] = responseData.response.email
            errors["user_name"] = responseData.response.user_name
            errors["password"] = responseData.response.password
            errors["opening_balance"] = responseData.response.opening_balance
          }
        }
        else if (responseData.status == true) {
          swal("", responseData.message, responseData.status ? "success" : "danger")
          history.push("/employee")
          // setInputValues("")
          setErrors({})
          console.log("in")
          toggle();
          ListEmployee(pages.current_page);
        }
        setErrors(errors)

        return responseData;
      }).catch(e => {
        console.log(e);
      });
  }
  const [inputValues, setInputValues] = useState({});
  const [list_data, setList] = useState([])
  const { isShowing, toggle } = UseModal();
  const [errors, setErrors] = useState([])
  const history = useHistory()
  const [success, setSuccess] = useState([])

  return (
    <>
      <div className="main-container page-wrap">
        <div className="d-md-flex">
          <Sidebar_Progress progress={3} />
          <div className="content-area">
            <LoginHeader page_title="" />



            <div className="container pb-3">

              <div class="row">
                <div className="col-md-12 mb-3 px-4 mt-3"><Link to="/MLA-coupon">
                  <a href="MLA-coupon" className="float-end btn btn-gray">Back</a>
                </Link></div>
              </div>

              <div className="row justify-content-center mt-md-3 mt-3 form-container">
                <div className="col-md-12">
                  <div className="form-wrap list-wrp">
                    <div className="row mb-3">
                      <div className="col-md">
                        <div className="row">
                          <div className="col-md-1 col-2 pe-0">
                            <img src={payment} width="25px" className="img-fluid" alt=".." />
                          </div>
                          <div className="col-md col pl-0">
                            <h3 className="table-title">Employees OPENING BALANCES</h3>
                          </div>
                          <div className="col-md">
                            <a className="btn btn-primary px-3 mb-md-0 mb-2 " data-bs-target="#employee" onClick={toggle}>employees</a>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="input-group mb-3 search">
                          <span className="input-group-text" id="basic-addon1">
                            <i className="fa fa-search" aria-hidden="true"></i>
                          </span>
                          <input type="text" className="form-control" placeholder="Search With Employee Name " value={search.search_keyword} onChange={handleSearch} onKeyPress={(event) => {
                            var key = event.keyCode || event.which;
                            if (key === 13) {

                            }
                          }} />
                        </div>
                      </div>
                    </div>
                    <div className="table-widget">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>Name</th>
                            <th>Address</th>
                            <th>Phone</th>
                            <th>Email</th>
                            <th>Designation</th>
                            <th>UserName</th>
                            <th >Opening balance</th>
                            <th>Credit/Debit</th>
                            <th >Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            list_data.map(employee => (
                              <tr>
                                <td>{employee.name}</td>
                                <td>{employee.address ? employee.address : "--"}</td>
                                <td>{employee.phone ? employee.phone : "--"}</td>
                                <td>{employee.email ? employee.email : "--"}</td>
                                <td>{employee.designation ? employee.designation : "--"}</td>
                                <td>{employee.user_name ? employee.user_name : "--"}</td>
                                <td>{employee.opening_balance ? employee.opening_balance : "--"}</td>
                                <td>{employee.debit_credit}</td>
                                <td><div className="d-flex icon-btn">
                                  <button onClick={() => edit_Employee(employee.id, employee.ac_name, employee.ac_name1)} >  <i className="fa fa-pencil" aria-hidden="true"></i>
                                  </button>
                                  <button data-bs-toggle="tooltip" data-bs-placement="bottom" title="Delete" onClick={() => delete_employee(employee.id)}>  <i className="fa fa-trash" aria-hidden="true"></i>

                                  </button>

                                  <div className="dropdown">
                                    <button className="dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                      <i className="fa fa-ellipsis-h" aria-hidden="true"></i>
                                    </button>
                                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                      <li><a className="dropdown-item" href="#"><i className="fa fa-user me-2" aria-hidden="true"></i>Action</a></li>
                                      <li><a className="dropdown-item" href="#"><i className="fa fa-user me-2" aria-hidden="true"></i>Another action</a></li>

                                    </ul>
                                  </div>


                                </div></td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                      <nav aria-label="Page navigation example">
                        <ul className="pagination justify-content-end">
                          {pages.total_pages > 1 && pages.pagination_items}
                        </ul>
                      </nav>
                    </div>
                  </div>
                  <div className="text-end mt-4"><a className="btn btn-primary px-3 mb-md-0 mb-2" onClick={(event) => history.push("/vendor-config")}>Continue</a></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {isShowing ? (<SaveModal
        isShowing={isShowing}
        hide={toggle}
        handleInputs={handleInputs}
        inputValues={inputValues}
        // list ={list}
        success={success}
        // list_data={list_data}
        // dropdownData ={dropdownData}
        handleSubmit={handleSubmit}
        errors={errors}
      />) : null
      }

      <Modal
        isOpen={isOpen}
        onRequestClose={toggleModal}
        contentLabel="My dialog"
        className="mymodal custommodal"
        overlayClassName="myoverlay"
      >
        <div class="modal-content">
          <div class="modal-title modal-header"><h5 class="modal-title" id="exampleModalLongTitle">EMPLOYEES OPENING BALANCES</h5><button type="button" onClick={toggleModal} class="btn-close" data-dismiss="modal" aria-label="Close"></button></div>
          <div class=" modal-body  modal-body"><p>Are you sure you want to delete this Employee</p></div>
          <div class="justify-content-end  modal-footer"><div class="d-flex">
            <button type="button" class="btn btn-secondary me-2" onClick={toggleModal}>No</button>
            <button type="submit" class="btn btn-primary" onClick={deleteEmployee}>Yes</button>
          </div>
          </div>
        </div>




      </Modal>

    </>
  )
}

export default EmployeeOpeningBalance